// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--372Oa","content":"style-module--content--26Xnt","section":"style-module--section--2Gxjj"};